"use client";

import { useTranslations } from "next-intl";
import type * as React from "react";
import {
  Alert,
  AlertContent,
  AlertDescription,
  AlertIcon,
} from "@/components/ui/alert";

interface ConstantsDriftBannerProps {
  driftedKey: string;
  expected: bigint | number;
  actual: bigint | number;
}

export const ConstantsDriftBanner: React.FC<ConstantsDriftBannerProps> = ({
  driftedKey,
}) => {
  const t = useTranslations("stake");

  return (
    <Alert variant="destructive" className="w-full">
      <AlertIcon>
        <span role="img" aria-label={t("banner.errorIcon")}>
          ⚠
        </span>
      </AlertIcon>
      <AlertContent>
        <AlertDescription>{t("banner.drift", { driftedKey })}</AlertDescription>
      </AlertContent>
    </Alert>
  );
};
